import {SlAlert, SlButton, SlDialog} from '../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {CookieManager} from '../common/cookieManager';
import {CheaperDialog} from './cheaperDialog';

export class RememberItems {
    private readonly MERKLISTE_COUNT_ACTION = '/merkliste_count';
    private readonly REMEMBER_TARIFF_ACTION = '/modulcmsapi/remembertarif/';
    private readonly SAVE_MICRO_ACTION = '/merkliste/save_microconversion';

    private readonly merklisteHeaderElement: HTMLElement | null; // Nur im Shortcode nicht vorhanden!
    private readonly shortcodeElement: HTMLElement | null;
    private readonly viewRoot: HTMLElement;
    private readonly cookieRegistrationLayerDismissed = 'REGISTER_LAYER_DISMISSED';
    private readonly cookieManager: CookieManager;

    constructor(viewRoot: HTMLElement) {
        this.cookieManager = new CookieManager();
        this.merklisteHeaderElement = document.getElementById('hf_merkliste');
        this.shortcodeElement = document.querySelector('.shortcode.internet_filter');
        this.viewRoot = viewRoot;

        this.registerEventListeners();
        this.loadMerklisteCount();
    }

    private registerEventListeners() {
        const rememberTarifs: NodeListOf<HTMLElement> = this.viewRoot.querySelectorAll('.rememberTarif');
        rememberTarifs.forEach((element) => {
            element.addEventListener('click', (event) => {
                this.handleTariffRememberClick(element, event);
            });
        });
    }

    private handleTariffRememberClick(rememberTariffElement: HTMLElement, event: Event): void {
        event.preventDefault();

        const artid = rememberTariffElement.dataset.artid ?? 0;
        let zusatz = '';
        if (artid !== 0) {
            zusatz = '?artid=' + artid;
        }
        fetch(this.REMEMBER_TARIFF_ACTION + rememberTariffElement.dataset.vtid + zusatz, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        })
            .then((response) => response.json())
            .then(({success}) => {
                //@todo: doppelte Herzen entfernen im DSL-Bereich: Tarife doppelt + Icons doppelt (mobil + desktop)
                const heartElements: NodeListOf<HTMLElement> = document.querySelectorAll(
                    `.rememberTarif[data-vtid="${rememberTariffElement.getAttribute('data-vtid')}"]`,
                );
                let tarifNameDataset = notNull(rememberTariffElement.dataset.tarifName);
                let tarifName = tarifNameDataset.slice(0, 20);
                if (tarifNameDataset.length > 20) {
                    tarifName = tarifName + '...';
                }
                const text = rememberTariffElement.dataset.text ?? '';

                let iconName: string;
                let message: string;
                let tooltipTitle: string;
                let tooltipContentText: string;
                if (success === 'insert') {
                    this.openRegisterDialog(rememberTariffElement);

                    iconName = 'heart-fill';
                    message = `<strong>${tarifName}</strong> zur Merkliste hinzugef\xFCgt`;
                    tooltipTitle = success === 'insert' ? 'Tarif gespeichert!' : 'Lieblingstarife merken';
                    tooltipContentText = 'Du findest alle Deine Lieblingstarife in Deiner Merkliste.';
                    rememberTariffElement.classList.add('active');
                } else {
                    iconName = 'heart';
                    message = `<strong>${tarifName}</strong> aus Merkliste entfernt`;
                    tooltipTitle = success === 'insert' ? 'Tarif gespeichert!' : 'Lieblingstarife merken';
                    tooltipContentText = 'Speichere Deine Lieblingstarife, indem Du auf das Herz tippst. Du findest Deine Favoriten in Deiner Merkliste.';
                    rememberTariffElement.classList.remove('active');
                }

                // setze das Herz ausgefuellt / nicht ausgefuellt
                heartElements.forEach((heartElement) => {
                    heartElement.innerHTML = `
                        <sl-tooltip placement="bottom-start" disabled>
                            <div slot="content">
                                <span class="title">${tooltipTitle} <sl-icon name="heart-fill"></sl-icon></span>
                                <span class="content">${tooltipContentText}</span>
                            </div>
                            <sl-icon name="${iconName}"></sl-icon>
                        </sl-tooltip>
                        <sl-icon class="heart-mobile" name="${iconName}"></sl-icon> ${text}
                    `;

                    let tooltip = heartElement.querySelector('sl-tooltip');
                    tooltip?.addEventListener('mouseleave', () => {
                        tooltip.removeAttribute('disabled');
                    });
                });

                this.showNotifyMessage(message, 'success', iconName);

                if (this.shortcodeElement) {
                    return;
                }

                this.loadMerklisteCount();

                // you can only remove tariffs from the list if you are on the merkliste page
                if (!document.body.classList.contains('merkliste') && !rememberTariffElement.closest('.rememberTarifslider')) {
                    return;
                }

                // aktualisiere beim loeschen die Liste bzw. die Anzeige der Anzahl
                rememberTariffElement.closest('.tarifbox')?.remove();

                const merklisteCount = document.querySelector('.merkliste-count') as HTMLElement;
                if (merklisteCount) {
                    merklisteCount.innerHTML = (parseInt(merklisteCount.innerHTML) - 1).toString();
                }
            });
    }

    private openRegisterDialog(rememberTariffElement: HTMLElement): void {
        if (this.cookieManager.getCookie(this.cookieRegistrationLayerDismissed)) {
            return;
        }
        const userRegistrationDialog: SlDialog | null = document.querySelector('.save-user-layer-dialog');
        if (!userRegistrationDialog) {
            return;
        }

        userRegistrationDialog.show();
        let art = '';
        let typ = '';

        const saveUserLayerOpen: SlButton | null = document.querySelector('sl-button.save-user-layer-open');
        if (saveUserLayerOpen) {
            art = notNull(saveUserLayerOpen.dataset.art);
            typ = 'MERKEN-' + notNull(saveUserLayerOpen.dataset.typ);
        } else {
            art = 'DETAIL';
            typ = 'MERKEN-' + notNull(rememberTariffElement.dataset.tariftyp);
        }

        this.saveMircoconversion(art, typ);

        this.cookieManager.setCookie(this.cookieRegistrationLayerDismissed, 'true');
    }

    private saveMircoconversion(art: string, typ: string): void {
        const formData = new FormData();
        formData.append('art', art);
        formData.append('typ', typ);

        fetch(this.SAVE_MICRO_ACTION, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        });
    }

    private showNotifyMessage(message: string, variant = 'primary', icon = 'info-circle'): void {
        let alertMsg = document.createElement('sl-alert') as SlAlert;
        alertMsg.setAttribute('variant', variant); // use this until we figure out how to validate the allowed variant set
        alertMsg.duration = 3000;
        alertMsg.closable = true;
        alertMsg.innerHTML = `<sl-icon name="${icon}" slot="icon" class="orange"></sl-icon>${message}`;
        alertMsg.className = 'merkliste-alert';

        document.body.append(alertMsg);

        alertMsg.show();
    }

    private loadMerklisteCount(): void {
        if (!this.merklisteHeaderElement) {
            return;
        }

        fetch(this.MERKLISTE_COUNT_ACTION, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok.');
                }

                return response.text();
            })
            .then((content) => {
                notNull(this.merklisteHeaderElement).innerHTML = content;

                new CheaperDialog();
            });
    }
}
